/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InvoicingDataPreviewReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The InvoicingDataPreviewReport model module.
   * @module model/InvoicingDataPreviewReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>InvoicingDataPreviewReport</code>.
   * @alias module:model/InvoicingDataPreviewReport
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>InvoicingDataPreviewReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InvoicingDataPreviewReport} obj Optional instance to populate.
   * @return {module:model/InvoicingDataPreviewReport} The populated <code>InvoicingDataPreviewReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('InvoiceNumber')) {
        obj['InvoiceNumber'] = ApiClient.convertToType(data['InvoiceNumber'], 'String');
      }
      if (data.hasOwnProperty('InvoicingCustomerName')) {
        obj['InvoicingCustomerName'] = ApiClient.convertToType(data['InvoicingCustomerName'], 'String');
      }
      if (data.hasOwnProperty('ProductSyncGroupName')) {
        obj['ProductSyncGroupName'] = ApiClient.convertToType(data['ProductSyncGroupName'], 'String');
      }
      if (data.hasOwnProperty('CustomerSyncGroupName')) {
        obj['CustomerSyncGroupName'] = ApiClient.convertToType(data['CustomerSyncGroupName'], 'String');
      }
      if (data.hasOwnProperty('Dimension1')) {
        obj['Dimension1'] = ApiClient.convertToType(data['Dimension1'], 'String');
      }
      if (data.hasOwnProperty('Dimension2')) {
        obj['Dimension2'] = ApiClient.convertToType(data['Dimension2'], 'String');
      }
      if (data.hasOwnProperty('Dimension3')) {
        obj['Dimension3'] = ApiClient.convertToType(data['Dimension3'], 'String');
      }
      if (data.hasOwnProperty('InvoiceDate')) {
        obj['InvoiceDate'] = ApiClient.convertToType(data['InvoiceDate'], 'Date');
      }
      if (data.hasOwnProperty('TotalNetSum')) {
        obj['TotalNetSum'] = ApiClient.convertToType(data['TotalNetSum'], 'Number');
      }
      if (data.hasOwnProperty('ProductCode')) {
        obj['ProductCode'] = ApiClient.convertToType(data['ProductCode'], 'String');
      }
      if (data.hasOwnProperty('ProductName')) {
        obj['ProductName'] = ApiClient.convertToType(data['ProductName'], 'String');
      }
      if (data.hasOwnProperty('AccountingSuggestion')) {
        obj['AccountingSuggestion'] = ApiClient.convertToType(data['AccountingSuggestion'], 'String');
      }
      if (data.hasOwnProperty('ProductLineNetSum')) {
        obj['ProductLineNetSum'] = ApiClient.convertToType(data['ProductLineNetSum'], 'Number');
      }
      if (data.hasOwnProperty('SellerIdentifier')) {
        obj['SellerIdentifier'] = ApiClient.convertToType(data['SellerIdentifier'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} InvoiceNumber
   * @default ''
   */
  exports.prototype['InvoiceNumber'] = '';
  /**
   * @member {String} InvoicingCustomerName
   * @default ''
   */
  exports.prototype['InvoicingCustomerName'] = '';
  /**
   * @member {String} ProductSyncGroupName
   * @default ''
   */
  exports.prototype['ProductSyncGroupName'] = '';
  /**
   * @member {String} CustomerSyncGroupName
   * @default ''
   */
  exports.prototype['CustomerSyncGroupName'] = '';
  /**
   * @member {String} Dimension1
   * @default ''
   */
  exports.prototype['Dimension1'] = '';
  /**
   * @member {String} Dimension2
   * @default ''
   */
  exports.prototype['Dimension2'] = '';
  /**
   * @member {String} Dimension3
   * @default ''
   */
  exports.prototype['Dimension3'] = '';
  /**
   * @member {Date} InvoiceDate
   */
  exports.prototype['InvoiceDate'] = undefined;
  /**
   * @member {Number} TotalNetSum
   * @default 0.0
   */
  exports.prototype['TotalNetSum'] = 0.0;
  /**
   * @member {String} ProductCode
   * @default ''
   */
  exports.prototype['ProductCode'] = '';
  /**
   * @member {String} ProductName
   * @default ''
   */
  exports.prototype['ProductName'] = '';
  /**
   * @member {String} AccountingSuggestion
   * @default ''
   */
  exports.prototype['AccountingSuggestion'] = '';
  /**
   * @member {Number} ProductLineNetSum
   * @default 0.0
   */
  exports.prototype['ProductLineNetSum'] = 0.0;
  /**
   * @member {String} SellerIdentifier
   * @default ''
   */
  exports.prototype['SellerIdentifier'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


